import { Button, Col, Form, Input, Row, Select, Space } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { DateRangeType, DateSelect } from '../../compnents/form/DateSelect'
import { ThemeContext } from '../../theme/ThemeContext'
import { unwrapResult } from '@reduxjs/toolkit'
import { getPatientLabels } from '../patient/list/patientListSlice'

const { Option } = Select

export const Query = (props: {
  loading?: any
  onValueChange: (queries: any) => void
  bindMember: () => void
  manageMember?: () => void
  addMember: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [labelList, setLabelList] = useState<any>([])

  const getLabelFn = (data: any) => {
    dispatch(getPatientLabels(data))
      .then(unwrapResult)
      .then((res: any) => setLabelList(res))
  }

  useEffect(() => {
    getLabelFn({ current: 1, size: 50 })
  }, [])

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      name='control-hooks'
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        // if (!values?.timeHead && values?._dateRange == 6) {
        //   return
        // }
        props?.onValueChange({
          ...values,
          labelIds: values?.labelIds?.join(','),
          startTime: values?.timeHead,
          endTime: values?.timeTail,
          actionTimeHead: undefined,
          actionTimeTail: undefined,
          current: 1,
        })
      }}
    >
      <Row
        style={{ marginBottom: 10, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='keyWord' noStyle>
            <Input
              allowClear
              maxLength={20}
              style={{ width: '20rem' }}
              onChange={(e) => {
                const val = e.target.value.trim()
                // 如果是数字且长度超过10位才提交，否则空值也提交
                if (/^\d+$/.test(val)) {
                  if (val.length >= 10) {
                    form.submit()
                  }
                } else {
                  form.submit()
                }
              }}
              placeholder='请输入患者姓名/手机号/助记码/会员卡号'
              prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
            />
          </Form.Item>
          <Form.Item name='labelIds' noStyle>
            <Select
              showSearch
              placeholder='标签选择'
              optionFilterProp='children'
              style={{ width: '12rem' }}
              mode='multiple'
              onChange={form.submit}
              onSearch={(v) => getLabelFn({ current: 1, size: 50, name: v })}
              filterOption={false}
            >
              {labelList.length &&
                labelList.map((v: any) => (
                  <Option key={v.id} value={v.id}>
                    {v.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <DateSelect
            style={{ width: '8.5rem' }}
            labelPrefix=''
            namePrefix='time'
            placeholder='时间范围-时间'
            // initialValue={DateRangeType.Today}
            onChange={form.submit}
          // allowClear={false}
          />
          <Button type='primary' htmlType='submit' loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            style={{ backgroundColor: '#FA8714', border: '1px solid #FA8714' }}
            onClick={() => {
              props?.bindMember()
            }}
          >
            会员卡绑定
          </Button>
          {props.manageMember && (
          <Button
            type='primary'
            style={{ backgroundColor: '#07C160', border: '1px solid #07C160' }}
            onClick={() => {
              props.manageMember!()
            }}
          >
            会员卡管理
          </Button>
          )}
          <Button
            type='primary'
            onClick={() => {
              props?.addMember()
            }}
          >
            新增会员
          </Button>
        </Space>
      </Row>
    </Form>
  )
}

export const MemberCardQuery = (props: {
  loading?: any
  onValueChange: (queries: any) => void
  addMemberCard: () => void
}): ReactElement => {
  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  return (
    <Form
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
      name='control-hooks'
      autoComplete='off'
      form={form}
      onFinish={(values) => {
        if (!values?.timeHead && values?._dateRange == 6) {
          return
        }
        props?.onValueChange({
          ...values,
          current: 1,
        })
      }}
    >
      <Row
        style={{ marginBottom: 15, width: '100%' }}
        align='middle'
        justify='space-between'
      >
        <Space>
          <Form.Item name='param' noStyle>
            <Input
              allowClear
              maxLength={20}
              style={{ width: '20rem' }}
              onChange={(e) => {
                const val = e.target.value.trim()
                // 如果是数字且长度超过10位才提交，否则空值也提交
                if (/^\d+$/.test(val)) {
                  if (val.length >= 10) {
                    form.submit()
                  }
                } else {
                  form.submit()
                }
              }}
              placeholder='请输入患者姓名/手机号/助记码/会员卡号'
              prefix={<SearchOutlined style={{ color: theme.tc3 }} />}
            />
          </Form.Item>
          <Form.Item name='bindState' noStyle>
            <Select
              allowClear
              placeholder='状态'
              style={{ width: '8rem' }}
              onChange={form.submit}
            >
              <Option key={0} value={0}>
                待绑定
              </Option>
              <Option key={1} value={1}>
                已绑定
              </Option>
            </Select>
          </Form.Item>
          <DateSelect
            style={{ width: '8.5rem' }}
            labelPrefix=''
            initialValue={DateRangeType.Today}
            namePrefix='time'
            placeholder='时间范围-时间'
            onChange={form.submit}
            allowClear={false}
          />
          <Button type='primary' htmlType='submit' loading={props?.loading}>
            查询
          </Button>
        </Space>
        <Space>
          <Button
            type='primary'
            onClick={() => {
              props?.addMemberCard()
            }}
          >
            新增会员卡
          </Button>
        </Space>
      </Row>
    </Form>
  )
}
